export const LOCAL_STORAGE_KEYS = {
  FeedGuidelineAcceptedTerms: 'GuidelineHomeFeedAcceptedTerms',
  GhGuidelineAcceptedTerms: 'GuidelineGroupHookupAcceptedTerms',
  GroupHookupsFinishTutorial: 'GroupHookupsFinishTutorial',
  HideGetStartedFeedOnboardingCard: 'HideGetStartedFeedOnboardingCard',
  NodeBBUserSlug: 'NodeBBUserSlug'
};
